import React, { useEffect, useState } from 'react';

export function Countdown() {
  const [timeLeft, setTimeLeft] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0
  });

  useEffect(() => {
    // Target Date: December 29, 2025
    const targetDate = new Date('2026-01-06T00:00:00').getTime();

    const interval = setInterval(() => {
      const now = new Date().getTime();
      const distance = targetDate - now;

      if (distance < 0) {
        clearInterval(interval);
        setTimeLeft({ days: 0, hours: 0, minutes: 0, seconds: 0 });
      } else {
        setTimeLeft({
          days: Math.floor(distance / (1000 * 60 * 60 * 24)),
          hours: Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
          minutes: Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)),
          seconds: Math.floor((distance % (1000 * 60)) / 1000)
        });
      }
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  const DigitBox = ({ value }: { value: string }) => (
    <div className="relative w-[45px] sm:w-[70px] md:w-[90px] h-[50px] sm:h-[80px] md:h-[100px] bg-[#ffbf00] border-2 border-black rounded-[10px] shadow-[3px_3px_0px_0px_black] md:shadow-[5px_5px_0px_0px_black] flex items-center justify-center">
      <span className="font-bold text-2xl sm:text-4xl md:text-6xl text-black">{value}</span>
    </div>
  );

  const TimeGroup = ({ value, label }: { value: number, label: string }) => {
    const valueStr = value.toString().padStart(2, '0');
    return (
      <div className="flex flex-col items-center gap-2">
        <div className="flex gap-2 sm:gap-4">
          <DigitBox value={valueStr[0]} />
          <DigitBox value={valueStr[1]} />
        </div>
        <span className="text-[rgb(0,0,0)] text-xs sm:text-lg md:text-xl tracking-wider font-[Roboto] font-bold font-sans">{label}</span>
      </div>
    );
  };

  return (
    <div className="flex gap-4 sm:gap-8 md:gap-12 justify-center">
      <TimeGroup value={timeLeft.days} label="DAYS" />
      <TimeGroup value={timeLeft.hours} label="HOURS" />
      <TimeGroup value={timeLeft.minutes} label="MINUTES" />
    </div>
  );
}
